module.exports = __webpack_public_path__ + "img/hue-saturation-3.c68e1878.png";